import { render, staticRenderFns } from "./DepositNewSummary.vue?vue&type=template&id=1b0ef6e3"
import script from "./DepositNewSummary.vue?vue&type=script&lang=js"
export * from "./DepositNewSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0ef6e3')) {
      api.createRecord('1b0ef6e3', component.options)
    } else {
      api.reload('1b0ef6e3', component.options)
    }
    module.hot.accept("./DepositNewSummary.vue?vue&type=template&id=1b0ef6e3", function () {
      api.rerender('1b0ef6e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/DepositNewSummary.vue"
export default component.exports